import React, { useContext } from "react";

import { NCRContext } from "views";
import { UserContext } from "components/routing";

import { Dropdown } from "components/form/prototypes";
import { Asterisk } from "components/form/prototypes";

const Subsidiary = () => {

  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled =
    ['QA', 'GM'].includes(user.role)
      ? state.ncr.status.id > 8
      : state.ncr.status.id > 1;

  return (
    <>
    <Asterisk/>
    <Dropdown
      name='ncr.subsidiary'
      label='Subsidiary'
      data={state.subsidiaries}
      required={true}
      disabled={isDisabled} />
    </>
  )
}

export { Subsidiary };
